import styled, { css } from 'styled-components/macro';

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    ${theme.fonts['heading-3'].css};
    color: ${theme.colors.gray[800]};
    margin-bottom: ${theme.spacings.s};
  `}
`;

export const MessageText = styled.div`
  ${({ theme }) => css`
    ${theme.fonts['body-14'].css};
    color: ${theme.colors.gray[800]};
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    width: ${theme.spacings.m};
    height: ${theme.spacings.m};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${theme.radiuses.xxxs};
    background-color: ${theme.colors.gray[100]};
  `}
`;

export const CardWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacings.s};
    border-radius: ${theme.radiuses.s};
    background-color: ${theme.colors.white};
  `}
`;
